<template>
  <div>
    <v-tabs v-model="tabOpen" color="info" dark show-arrows v-if="budget">
      <v-tabs-slider color="info darken-2"></v-tabs-slider>
      <v-tab v-for="item in itemsTab" :href="'#tab-' + item" :key="'#tab-' + item" >
       {{item}} </v-tab>
      <v-tabs-items>
        <v-tab-item :value="'tab-Equipamentos'" v-if="budget.inputsVariables">
          <attachment attachment="equipments" filter="Equipamento" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>
        
        <v-tab-item :value="'tab-Materiais de Consumo'" v-if="budget.inputsVariables">
          <attachment attachment="consumables" filter="Material de Consumo" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>

        <v-tab-item :value="'tab-Uniformes e EPIs'" v-if="budget.inputsVariables">
          <attachment attachment="uniformsAndEPIs" filter="Uniforme e EPI's" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>

        <v-tab-item :value="'tab-Utensílios'" v-if="budget.inputsVariables">
          <attachment attachment="utensils" filter="Utensílio" :inputsVariables="budget.inputsVariables"></attachment>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  // COMPONENTS //
  
  
  import Attachment from "../../components/budget/AttachmentVariable";
  

  export default {
    components: {
      Attachment
    },
    data: () => ({
      itemsTab: ["Equipamentos", "Materiais de Consumo", "Uniformes e EPIs",  "Utensílios"],
      tabOpen: 'tab-Equipamentos'
    }),
    computed: {
      ...mapState({budget: state => state.budget.budget}),
    },
    created() {
      this.$eventHub.$on("initTabs", _ => {
        this.tabOpen = 'tab-' + this.itemsTab[0]
      });      
    }
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/Inputs.vue